import KoboConverter from "Components/KoboConverter";
import { useGetCustomerWalletActivitiesQuery } from "hooks/CustomerManagement/useGetCustomerWalletActivitiesQuery";
import { useGetCustomerWalletBalanceQuery } from "hooks/CustomerManagement/useGetCustomerWalletBalanceQuery";
import React from "react";
import Moment from "react-moment";
import { useParams } from "react-router-dom";

const PersonalData = (data: any) => {
  const { id } = useParams();
  // const { data : } = useGetCustomerWalletActivitiesQuery({ id });
  const { data: balance } = useGetCustomerWalletBalanceQuery({ id });
  return (
    <div className="border-r-[1px] border-[#eeeeee]">
      <h2 className="text-[#562B00] text-[20px] font-semibold pt-[20px] mb-[30px]">
        Personal Details
      </h2>
      <div className="flex">
        <div className="relative w-5/12">
          <img
            src={data?.data?.profileImage ? data?.data?.profileImage : ""}
            alt="User Avatar"
            className="h-[315px] rounded-[20px] w-full object-cover bg-gray"
          />
          <div
            className={`${
              !data?.data?.isSuspended
                ? "bg-[#E3FFEB] text-[#0CA364]"
                : "bg-[#fff2e3] text-[#f00]"
            } absolute bottom-[30px] left-1/2 transform -translate-x-1/2  text-center text-[14px]  px-4 py-2 rounded-full`}
          >
            Status: {!data?.data?.isSuspended ? "Active" : "InActive"}
          </div>
        </div>

        <div className="w-1/12" />
        <div className="w-6/12">
          <h3 className="text-[#a8a8a8] mb-[5px]">Name</h3>
          <p className="text-black mb-[30px]">
            {data?.data?.firstName + " " + data?.data?.lastName}
          </p>
          <h3 className="text-[#a8a8a8] mb-[5px]">Gender</h3>
          <p className="text-black mb-[30px]">
            {data?.data?.gender ? data?.data?.gender : "n/a"}
          </p>
          <h3 className="text-[#a8a8a8] mb-[5px]">Date Of Birth</h3>
          <p className="text-black mb-[30px]">
            {data?.data?.dateOfBirth ? (
              <Moment interval={0} format="DD-MM-YYYY">
                {data?.data?.dateOfBirth}
              </Moment>
            ) : (
              "n/a"
            )}
          </p>
          <h3 className="text-[#a8a8a8] mb-[5px]">Nationality</h3>
          <p className="text-black mb-[30px]">Nigerian</p>
        </div>
      </div>
      <div className="flex">
        <div className="w-6/12">
          <h2 className="text-[#562B00] text-[20px] font-semibold mt-[20px] mb-[30px]">
            Address
          </h2>
          <h3 className="text-[#a8a8a8] mb-[5px]">Address Line</h3>
          <p className="text-black mb-[30px] w-11/12">
            {`${data?.data?.businessAddress?.businessNo || ""} ${
              data?.data?.businessAddress?.streetName || ""
            }`.trim()}
          </p>
          <h3 className="text-[#a8a8a8] mb-[5px]">City</h3>
          <p className="text-black mb-[30px]">
            {data?.data?.businessAddress?.city
              ? data?.data?.businessAddress?.city
              : "n/a"}{" "}
          </p>
          <h3 className="text-[#a8a8a8] mb-[5px]">State</h3>
          <p className="text-black mb-[30px]">
            {data?.data?.businessAddress?.state
              ? data?.data?.businessAddress?.state
              : "n/a"}{" "}
          </p>
          <h3 className="text-[#a8a8a8] mb-[5px]">Country</h3>
          <p className="text-black mb-[30px]">
            {data?.data?.businessAddress?.country
              ? data?.data?.businessAddress?.country
              : "n/a"}{" "}
          </p>
        </div>
        <div className="w-6/12">
          <h2 className="text-[#562B00] text-[20px] font-semibold mt-[20px] mb-[30px]">
            Balances
          </h2>
          <h3 className="text-[#a8a8a8] mb-[5px]">Loan Balance </h3>
          <p className="text-black mb-[30px] w-11/12">
            <KoboConverter amount={balance?.data?.loanBalance} />
          </p>
          <h3 className="text-[#a8a8a8] mb-[5px]">Wallet Balance </h3>
          <p className="text-black mb-[30px] w-11/12">
            <KoboConverter amount={balance?.data?.availableBalance} />
          </p>

          <h2 className="text-[#562B00] text-[20px] font-semibold mt-[20px] mb-[30px]">
            Contact Details
          </h2>
          {/* <h3 className="text-[#a8a8a8] mb-[5px]">Nationality</h3> */}
          <h3 className="text-[#a8a8a8] mb-[5px]">Phone Number</h3>
          <p className="text-black mb-[30px] w-11/12">
            {data?.data?.phoneNumber ? data?.data?.phoneNumber : "n/a"}
          </p>
          <h3 className="text-[#a8a8a8] mb-[5px]">Email Address</h3>
          <p className="text-black mb-[30px] w-11/12">
            {data?.data?.email ? data?.data?.email : "n/a"}
          </p>

          <h2 className="text-[#562B00] text-[20px] font-semibold mt-[20px] mb-[30px]">
            Account
          </h2>
          <h3 className="text-[#a8a8a8] mb-[5px]">Current Tier</h3>
          <p className="text-black mb-[30px] w-11/12">
            {data?.data?.tier ? data?.data?.tier : "n/a"}
          </p>
          <h3 className="text-[#a8a8a8] mb-[5px]">Date Joined</h3>
          <p className="text-black mb-[30px] w-11/12">
            {data?.data?.createdAt ? (
              <Moment interval={0} format="DD-MM-YYYY">
                {data?.data?.createdAt}
              </Moment>
            ) : (
              "n/a"
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PersonalData;
